import React, { Component } from 'react';
import { connect } from 'react-redux';
import VideoForm from './VideoForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class VideoDetail extends Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('video_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return (
      <div>
        <VideoForm
          edit
          title="Video Detail"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, index, email } })=>({
  guardData: { isFetch, roles, isLogged, index, email }
})

const enhance = connect(mapStateToProps);
export default enhance(privateView(VideoDetail))